import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_slider = _resolveComponent("el-slider");
  return _openBlock(), _createBlock(_component_el_slider, {
    modelValue: _ctx.innerValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.innerValue = $event),
    min: _ctx.min,
    max: _ctx.max,
    step: _ctx.step,
    disabled: _ctx.disabled,
    "show-input": _ctx.showInput,
    "show-input-controls": _ctx.showInputControls,
    "show-stops": _ctx.showStops,
    "show-tooltip": _ctx.showTooltip,
    range: _ctx.range,
    vertical: _ctx.vertical,
    height: _ctx.height,
    label: _ctx.label,
    debounce: _ctx.debounce,
    "tooltip-class": _ctx.tooltipClass,
    marks: _ctx.marks,
    class: "w-slider",
    onChange: _ctx.handleChange,
    onInput: _ctx.handleInput
  }, null, 8, ["modelValue", "min", "max", "step", "disabled", "show-input", "show-input-controls", "show-stops", "show-tooltip", "range", "vertical", "height", "label", "debounce", "tooltip-class", "marks", "onChange", "onInput"]);
}